import { render, staticRenderFns } from "./NftHistory.vue?vue&type=template&id=0c04be10"
import script from "./NftHistory.vue?vue&type=script&lang=js"
export * from "./NftHistory.vue?vue&type=script&lang=js"
import style0 from "./NftHistory.vue?vue&type=style&index=0&id=0c04be10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports